import { render } from "./BackDetailView.vue?vue&type=template&id=a10e53b8"
import script from "./BackDetailView.vue?vue&type=script&lang=js"
export * from "./BackDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__